import { Modal, Radio, Tooltip } from '@mui/material'
import React, { useState, useEffect } from 'react'
import cssClasses from './SelectRepeatedEvent.module.css'
import CloseIcon from "@mui/icons-material/Close";
import Datagrid from '../Datagrid';
import SearchBar from '../Search';
import DropDown from '../DropDown';
import LeadStatusChip from '../LeadStatusChip';
import eventIcon from '../../Assets/Images/Common/Browser.svg'
import { makeStyles } from "@mui/styles";
import Dot from '../../Components/Icons/Dot';
import { getEventsToRepeat } from '../../Services/Event';
import Button from '../Button';
import { cloneDeep } from 'lodash';
import { errorTost } from '../../Services/Toast';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    Tooltip: {
        '&.MuiTooltip-tooltip': {
            'fontSize': '1.2rem'
        }
    }
}))
export default function SelectRepeatedEvent({ openModal, setOpenModal,setIsRepeated, setRepeatedEventId, repeatedEventId, copyConfig }) {
    const classes = useStyles();
    const params = useParams()
    const eventId = params.eventId
    const [allEvents, setAllEvents] = useState([])
    const [search, setSearch] = useState('')

    const eventGridColums = [
        {
            field: "title",
            headerName: "Event",
            width: 400,
            renderCell: (params) => {
                return (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem'
                    }}>
                        <div>
                            <Radio checked={params.row?.isSelected} onChange={(e) => { EventSelected(e, params) }} />
                        </div>
                        {params.row.bannerImgUrl ?
                            <img style={{
                                width: '4rem',
                                height: '4rem',
                                objectFit: 'cover',
                                borderRadius: '50%'
                            }} src={process.env.REACT_APP_SUPABASE_BUCKET_PREFIX + params.row.bannerImgUrl + `?${Date.now()}`} alt="" />
                            :
                            <div style={{
                                background: '#FDB022',
                                borderRadius: '50%',
                                textAlign: 'center'
                            }}>
                                <img style={{ margin: "0.8rem 1rem 0.4rem 1rem" }} src={eventIcon} alt="" />
                            </div>
                        }
                        <div>
                            <Tooltip className={classes.Tooltip} placement='bottom-start' title={<p style={{ fontSize: "1.2rem" }}>{params.row.title}</p>}>
                                <p style={{ fontSize: "1.4rem" }}>{params.row.title}</p>
                            </Tooltip>
                        </div>
                    </div>
                )
            }
        },
        {
            field: "startDateTime",
            headerName: "Start Date Time",
            width: 250
        },
        {
            field: "endDateTime",
            headerName: "End Date Time",
            width: 250
        },
    ]

    function EventSelected(e, params) {
        setRepeatedEventId(null)
        let arr = cloneDeep(allEvents)
        arr.forEach((ele, index) => {
            if (ele.eventId === params.row.eventId) {
                ele.isSelected = true
            } else {
                ele.isSelected = false
            }
            if (arr.length - 1 === index) {
                setAllEvents([...arr])
            }
        })
    }

    useEffect(() => {
        if (allEvents.length === 0) {
            getEventsToRepeat().then((resp) => {
                console.log(resp)
                resp.data.forEach((ele, index) => {
                    if (eventId !== ele.eventId) {
                        if (repeatedEventId?.repeatedEventId === ele.eventId) {
                            ele.isSelected = true;
                        } else {
                            ele.isSelected = false;
                        }
                        ele.show = true; ele.id = ele.eventId; ele.startDateTime = new Date(ele.startDateTime).toLocaleString(); ele.endDateTime = new Date(ele.endDateTime).toLocaleString(); ele.index = index
                    }
                })
                setAllEvents(resp.data)
            }).catch((err) => {
                console.log(err)
            })
        } else {
            if (search === '') {
                allEvents.forEach((e, index) => { setAllEvents((pre) => { pre[index].show = true; return [...pre] }) })
            } else {
                allEvents.forEach((ele) => {
                    if (!ele.title.toUpperCase().includes(search.toUpperCase())) {
                        setAllEvents((pre) => { pre[pre.findIndex((e) => e.title === ele.title)].show = false; return [...pre] })
                    } else {
                        setAllEvents((pre) => { pre[pre.findIndex((e) => e.title === ele.title)].show = true; return [...pre] })
                    }
                })
            }
        }
    }, [search])

    return (
        <Modal
            open={openModal}
            onClose={() => setOpenModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <div className={cssClasses.container}>
                <div className={cssClasses.header}>
                    <p className={cssClasses.heading}>Select Event</p>
                    <CloseIcon
                        sx={{ fontSize: "3rem", cursor: "pointer" }}
                        onClick={() => {setOpenModal(false);setIsRepeated(false)}}
                    />
                </div>
                <div className={cssClasses.mainContainer}>
                    <div className={cssClasses.header2}>
                        <div className={cssClasses.titleWrapper}>
                            <div className={cssClasses.title}>
                                <p>All Events</p>
                            </div>
                        </div>
                        {/* <div className={}>
                    <div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    </div>
                </div> */}
                    </div>
                    <div className={cssClasses.content}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5rem',
                            marginTop: '1.6rem'
                        }}>
                            <div className={cssClasses.totalEvents}>
                                {allEvents.filter((e) => { return e.eventId !== eventId }).length > 1 ?
                                    <p>{allEvents.filter((e) => { return e.eventId !== eventId }).length} Events</p>
                                    :
                                    <p>{allEvents.filter((e) => { return e.eventId !== eventId }).length} Event</p>
                                }
                            </div>
                            <div className={cssClasses.actionWrapper}>
                                {/* <div className={cssClasses.filterWrapper}>
                                <div className={cssClasses.label}>
                                    <p>Filter by</p>
                                </div>
                                <div className={cssClasses.dropdownWrapper}>
                                    <DropDown onChangeSelect={(e) => { setFilterBy(e) }} selectedValue={filterBy} style={{ selectedColor: "#175CD3", background: "#E8F0FE" }} list={["All", "Live", "Upcoming", "Closed"]} />
                                </div>
                            </div> */}
                                <div className={cssClasses.searchWrapper}>
                                    <SearchBar placeholder={"Search by event name"} search={(e) => { setSearch(e.target.value) }} id={'eventSearchBar'} />
                                </div>
                            </div>
                        </div>
                        <div className={cssClasses.gridWrapper}>
                            <Datagrid
                                // pageChanged={pageChanged}
                                hideFooter={false}
                                columns={eventGridColums}
                                rows={allEvents.filter((e) => { return e.show === true })}
                            />
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            marginTop: '2rem'
                        }}>
                            <div>
                                <Button
                                    clicked={() => {
                                        if (allEvents.filter((e) => { return e.isSelected === true }).length > 0) {
                                            setRepeatedEventId({ clone: true, repeatedEventId: allEvents.filter((e) => { return e.isSelected === true })[0].eventId, repeatedEventName: allEvents.filter((e) => { return e.isSelected === true })[0].title })
                                            setOpenModal(false)
                                            copyConfig(allEvents.filter((e) => { return e.isSelected === true })[0].eventId)
                                        } else {
                                            errorTost("Please select an event to continue")
                                        }
                                    }}
                                    btnName={"Save"}
                                    style={{
                                        borderRadius: "0.4rem",
                                        backgroundColor: "#1570EF",
                                        color: "#FFFFFF",
                                        fontSize: "1.6rem",
                                    }}
                                    padding={"0.5rem 1rem"}
                                    iconPosition={"left"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
